import React, {useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {FormattedMessage} from 'react-intl';

import {IStore} from 'redux/interface';
import {
  getSearchDialogue,
  getTranslations,
  searchAsyncActions
} from 'redux/pageAsyncActions';
import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {BotType} from 'utils/hooks/use-chat-bot/interfaces';
import {Pages, TranslationKeys} from 'utils/constants/routeConstants';

import BotChat from 'components/bot-chat';

import {closeArticle} from 'redux/content/actions';
import XpeditionIcon from 'assets/image/menu-auth/xpedition.png';
import {Link, useParams} from 'react-router-dom';

import './styles.scss';
import {BotMode} from '@wholesalechange/chatcomponent';

export const SearchChat: React.FunctionComponent = () => {
  const {
    loading
  } = useSelector((state: IStore) => state.status);
  const {
    searchDialogue
  } = useSelector((state: IStore) => state.search);
  const {
    settings
  } = useSelector((state: IStore) => state.auth);
  const dispatch = useDispatch();
  const {dialogueId} = useParams();

  useEffect(() => {
    dispatch(closeArticle());
  }, []);

  useEffect(() => {
    if (dialogueId) {
      dispatch(searchAsyncActions[getSearchDialogue](Number(dialogueId)));
    }
  }, [dialogueId]);

  const translationKey = useMemo(() => {
    const page = settings?.pages.find((p) => p.name.toLowerCase() === Pages.Search.toLowerCase());

    return page?.translationKey || TranslationKeys.Search;
  }, [settings]);

  useGetTranslations({translationKey});

  const title = useMemo(() => {
    const page = settings?.pages.find((p) => p.name.toLowerCase() === Pages.Search.toLowerCase());

    return page?.title || Pages.Search;
  }, [settings]);

  function renderBreadcrumbs() {
    return <div className="breadcrumbs">
      <Link className="breadcrumbs__previous" to="/search">
        <FormattedMessage
          id={`gritx.common.navigation.${title}`}
          defaultMessage={title}
        />
      </Link> {searchDialogue && <span className="search-chat__title-dialogue-name"> - {searchDialogue.dialogName}</span>}
    </div>;
  }

  return <div className="search-chat">
    {
      !loading.includes(getTranslations) && searchDialogue && <>
        <h1 className="search-chat__title">
          <img src={XpeditionIcon} alt="" className="search-chat__icon"/>
          {renderBreadcrumbs()}
        </h1>
        <BotChat chatType={BotType.Xpedition} chatMode={BotMode.NoHistory} dialogueId={searchDialogue.dialogId}
          title={searchDialogue.dialogName}
          tabsEnabled={settings?.chatSettings?.tabsEnabled || false}/>
      </>
    }
  </div>;
};
